//
// KeyValue.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../Region";
import "../../data/ClassificationRole";
import "../../data/AnalysisRole";
import "../../core/styles/TextAttributes";
import "./KeyValueCategorySelect";
import "./KeyValueDisplay";
import "../../core/styles/FillAttributes";
import "./KeyValueHAlign";
import "./KeyValueJustify";
import "./KeyValueKey";
import "../../core/styles/LineAttributes";
import "./KeyValueResponseValueFormatOptions";
import "./KeyValueShape";
import "./KeyValueStatisticLabel";
import "./KeyValueVAlign";

var KeyValue = createModule("gtl::KeyValue", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization","gtl::Region"], EventDispatcher, [
    ,
    {
        categorySelect: 4,
        outlineAttributes: 1,
        statistic: 4,
        categoryLabelAttributes: 1,
        hAlign: 4,
        responseLabelAttributes: 1,
        shape: 4,
        display: 1,
        keyAttributes: 1,
        categoryLabel: 7,
        responseValueFormatOptions: 1,
        vAlign: 4,
        responseLabel: 7,
        categoryValueAttributes: 1,
        fillAttributes: 1,
        statisticLabelAttributes: 1,
        response: 1,
        justify: 4,
        categorySelectAttributes: 1,
        spaceFill: 2,
        category: 1,
        key: 4,
        responseValueAttributes: 1,
    },
    ,
    ,
    {
        getResolvedDisplay: [1],
    },
    {
        _create: [4],
    },
    ,
]);
export default KeyValue;
